import { apiClient } from '@store/index';
import { AIToolCreate, AIToolDelete } from '.';
import { axiosErrorMiddleware } from '@requests/common';
import { AITool } from '@components/Workspace/routes/Assistants/Assistant/AssistantTools/tool.types';
import { QueryFunctionContext } from '@tanstack/react-query';

const list = async ({ queryKey }: QueryFunctionContext<[string, string | undefined]>): Promise<AITool[]> => {
  const [, assistantId] = queryKey;

  const url = `/assistants/${assistantId}/tools`;
  const response = await apiClient.get<AITool[]>(url);
  return response.data.sort((a, b) => a.name.localeCompare(b.name));
};

const listAll = async (): Promise<AITool[]> => {
  const response = await apiClient.get<AITool[]>('/assistants/tools');
  return response.data.sort((a, b) => a.name.localeCompare(b.name));
};

const create = async ({ assistantId, tool }: AIToolCreate) => {
  try {
    await apiClient.post(`/assistants/${assistantId}/tools`, { tool });
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const update = async ({ assistantId, tool }: AIToolCreate): Promise<string | undefined> => {
  try {
    const url = `/assistants/${assistantId}/tools/${tool.id}`;
    const response = await apiClient.patch<{ success: true; tool_id: string | undefined }>(url, { tool });
    return response.data.tool_id;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

const remove = async ({ assistantId, toolId, type }: AIToolDelete) => {
  try {
    await apiClient.delete(`/assistants/${assistantId}/tools/${toolId}/${type}`);
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};

export default { list, create, update, remove, listAll };
